import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IMetaData, TrendencySeoService } from '@trendency/utils';
import * as moment from 'moment';
import { BaseService } from '../../../../core/components/base/base.service';
import { ApiService } from '../../../../shared/services/api.service';
import { ComponentMapService } from '../../../../shared/services/component-map.service';
import { IComponentFieldData } from '../../../../shared/shared.definitions';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-ginop-list',
  templateUrl: './ginop-list.component.html',
  styleUrls: ['./ginop-list.component.scss'],
})
export class GinopListComponent implements OnInit, OnDestroy {
  eventList: any = [];
  image: IComponentFieldData;
  data: any;
  private readonly destroy$ = new Subject();

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly apiService: ApiService,
    private readonly componentMapService: ComponentMapService,
    private readonly seo: TrendencySeoService,
    private readonly baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.data = this.activatedRoute.snapshot?.data?.['data']?.data;
    if (this.data?.body) {
      const ginopEventCollection = this.data?.body.find((component: any) => component.type === 'Body.Collection.GinopEventCollection');

      if (ginopEventCollection?.fields?.length) {
        this.image = ginopEventCollection.fields.find((field: any) => field.type === 'Reference.Image.ContentHeroImage');

        for (const field of ginopEventCollection.fields) {
          if (field?.value && field?.type === 'Reference.ContentPageOnlyGinopEvent') {
            const image = field.value.image;
            if (image) {
              this.apiService.getImageByUuid$(image).pipe(takeUntil(this.destroy$)).subscribe((img) => {
                field.value.imageObj = img.data;
              });
            }
            if (field?.value?.deadline) {
              field.value.overOfDeadline = this.getOverOfDeadline(field.value.deadline);
            }
            field.value.exhibitorReg = !!field.value.exhibitorReg;
            field.value.participantReg = !!field.value.participantReg;

            this.eventList.push(field.value);
          }
        }
      }
    }

    if (this.data?.meta) {
      this.setMetaData();

      this.baseService.setSz2020Logo(
        this.componentMapService.getComponentAsObjectByType(this.data?.meta, 'Meta.GinopLogoStatus')?.ginopLogoStatus
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  setMetaData(): void {
    const metaTitle = this.componentMapService.getComponentAsObjectByType(this.data.meta, 'Meta.Title');
    const metaLead = this.componentMapService.getComponentAsObjectByType(this.data.meta, 'Meta.Lead');
    const metaThumbnail = this.componentMapService.getComponentAsObjectByType(this.data.meta, 'Meta.Thumbnail');
    const metaData: IMetaData = {
      title: metaTitle.text,
      description: metaLead.text,
      ogTitle: metaTitle.text,
      ogImage: metaThumbnail?.image?.url,
      ogImageAlt: metaThumbnail?.image?.image?.title,
    };
    this.seo.setMetaData(metaData);
  }

  getOverOfDeadline(date: Date): boolean {
    return moment().isAfter(moment(date));
  }
}
